import React, { Component } from "react";

import Button from "components/button/button";

import "./checkout.css";

class Checkout extends Component {
  render() {
    return (
      <div className="checkout">
        <a href={this.props.url} target="_blank" rel="noopener noreferrer">
          <Button color="orange">
            <p>
              Checkout
              <span style={{ letterSpacing: "-6px", paddingLeft: "7px" }}>
                ––––›
              </span>
            </p>
          </Button>
        </a>
      </div>
    );
  }
}
export default Checkout;
